import { Component, Inject } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { OrderStatus, StatusHistoryOrderEnum } from '../../models/order.enum'
import { SharedService } from 'src/app/shared/services/shared.service'

@Component({
	selector: 'app-history-status-popup',
	templateUrl: './history-status-popup.component.html',
	styleUrl: './history-status-popup.component.scss',
})
export class HistoryStatusPopupComponent {
	orderStatus = this.sharedServ.returnEnumArray(OrderStatus)
	historyData: any
	constructor(
		private sharedServ: SharedService,
		public dialog: MatDialogRef<HistoryStatusPopupComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any
	) {
		this.historyData = data.historyData
	}

	statusHistoryImage(status: number) {
		let image = ''
		switch (status) {
			case 1:
				image = 'assets/images/bag.svg'
				break
			case 2:
				image = 'assets/images/clock.svg'
				break
			case 3:
				image = 'assets/images/tick-circle.svg'
				break
			case 4:
				image = 'assets/images/bag-tick.svg'
				break
			case 5:
				image = 'assets/images/truck-fast.svg'
				break
			case 6:
				image = 'assets/images/truck-tick.svg'
				break
			case 7:
				image = 'assets/images/close-circle.svg'
				break
			case 8:
				image = 'assets/images/empty-wallet-time.svg'
				break
			case 9:
				image = 'assets/images/empty-wallet-change.svg'
				break

			default:
				break
		}
		return image
	}
	closeDialog() {
		this.dialog.close()
	}
}
